export default __webpack_public_path__ + "static/media/trash.5c021e89.svg";